import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {TitleService} from '../core/title.service';
@Component({
    selector: 'sam4-viewer-not-active',
    templateUrl: './viewer-not-active.component.html',
    styleUrls: ['./viewer-not-active.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ViewerNotActiveComponent implements OnInit {

  constructor(private title: TitleService) { }

  ngOnInit(): void {
      this.title.set('Viewer Not Active');
  }

}
